export const TEST_IDS = {
  banksAutocomplete: "banks-autocomplete",
  currency: "account-currencies",
  formSubmitButton: "form-submit-button",
  listHeaderCheckbox: "list-header-checkbox",
  regionTreeSelect: "region-tree-select",
  contactSupportLink: "contact-support-link",
  getAutocomplete: (id: string) => `${id}-autocomplete`,
  getError: (id: string) => `${id}-error`,
  getCard: (id: string) => `${id}-card`,
  getCheckbox: (id: string) => `${id}-checkbox`,
  getCountry: (id: string) => `country-${id}`,
  getForm: (name: string) => `${name}-form`,
  getItems: (id: string) => `${id}-items`,
  getRegion: (id: string) => `region-${id}`,
} as const;
